function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:none;stroke:#666;stroke-miterlimit:10;}.cls-2{fill:#666;}"));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_2-2",
  "data-name": "Layer 2"
}, React.createElement("circle", {
  className: "cls-1",
  cx: 4.8,
  cy: 4.8,
  r: 3.33
}), React.createElement("rect", {
  className: "cls-2",
  x: 4.3,
  width: 1,
  height: 1
}), React.createElement("rect", {
  className: "cls-2",
  x: 1.26,
  y: 1.26,
  width: 1,
  height: 1,
  transform: "translate(-0.73 1.76) rotate(-45)"
}), React.createElement("rect", {
  className: "cls-2",
  y: 4.3,
  width: 1,
  height: 1,
  transform: "translate(-4.3 5.3) rotate(-90)"
}), React.createElement("rect", {
  className: "cls-2",
  x: 1.26,
  y: 7.35,
  width: 1,
  height: 1,
  transform: "translate(-2.54 14.64) rotate(-135)"
}), React.createElement("rect", {
  className: "cls-2",
  x: 4.3,
  y: 8.61,
  width: 1,
  height: 1,
  transform: "translate(9.61 18.22) rotate(-180)"
}), React.createElement("rect", {
  className: "cls-2",
  x: 7.35,
  y: 7.35,
  width: 1,
  height: 1,
  transform: "translate(18.94 7.85) rotate(135)"
}), React.createElement("rect", {
  className: "cls-2",
  x: 8.61,
  y: 4.3,
  width: 1,
  height: 1,
  transform: "translate(13.91 -4.3) rotate(90)"
}), React.createElement("rect", {
  className: "cls-2",
  x: 7.35,
  y: 1.26,
  width: 1,
  height: 1,
  transform: "translate(3.54 -5.03) rotate(45)"
}), React.createElement("circle", {
  className: "cls-1",
  cx: 7.85,
  cy: 15.1,
  r: 3.33
}), React.createElement("rect", {
  className: "cls-2",
  x: 7.35,
  y: 10.29,
  width: 1,
  height: 1
}), React.createElement("rect", {
  className: "cls-2",
  x: 4.31,
  y: 11.55,
  width: 1,
  height: 1,
  transform: "translate(-7.11 6.93) rotate(-45)"
}), React.createElement("rect", {
  className: "cls-2",
  x: 3.05,
  y: 14.6,
  width: 1,
  height: 1,
  transform: "translate(-11.55 18.64) rotate(-90)"
}), React.createElement("rect", {
  className: "cls-2",
  x: 4.31,
  y: 17.64,
  width: 1,
  height: 1,
  transform: "translate(-4.62 34.36) rotate(-135)"
}), React.createElement("rect", {
  className: "cls-2",
  x: 7.35,
  y: 18.9,
  width: 1,
  height: 1,
  transform: "translate(15.7 38.8) rotate(-180)"
}), React.createElement("rect", {
  className: "cls-2",
  x: 10.39,
  y: 17.64,
  width: 1,
  height: 1,
  transform: "translate(31.42 23.26) rotate(135)"
}), React.createElement("rect", {
  className: "cls-2",
  x: 11.65,
  y: 14.6,
  width: 1,
  height: 1,
  transform: "translate(27.25 2.94) rotate(90)"
}), React.createElement("rect", {
  className: "cls-2",
  x: 10.39,
  y: 11.55,
  width: 1,
  height: 1,
  transform: "translate(11.71 -4.17) rotate(45)"
}), React.createElement("circle", {
  className: "cls-1",
  cx: 14.78,
  cy: 7.85,
  r: 3.33
}), React.createElement("rect", {
  className: "cls-2",
  x: 14.28,
  y: 3.05,
  width: 1,
  height: 1
}), React.createElement("rect", {
  className: "cls-2",
  x: 11.23,
  y: 4.31,
  width: 1,
  height: 1,
  transform: "translate(0.04 9.71) rotate(-45)"
}), React.createElement("rect", {
  className: "cls-2",
  x: 9.97,
  y: 7.35,
  width: 1,
  height: 1,
  transform: "translate(2.62 18.32) rotate(-90)"
}), React.createElement("rect", {
  className: "cls-2",
  x: 11.23,
  y: 10.39,
  width: 1,
  height: 1,
  transform: "translate(12.33 26.89) rotate(-135)"
}), React.createElement("rect", {
  className: "cls-2",
  x: 14.28,
  y: 11.65,
  width: 1,
  height: 1,
  transform: "translate(29.55 24.31) rotate(-180)"
}), React.createElement("rect", {
  className: "cls-2",
  x: 17.32,
  y: 10.39,
  width: 1,
  height: 1,
  transform: "translate(38.12 6) rotate(135)"
}), React.createElement("rect", {
  className: "cls-2",
  x: 18.58,
  y: 7.35,
  width: 1,
  height: 1,
  transform: "translate(26.93 -11.23) rotate(90)"
}), React.createElement("rect", {
  className: "cls-2",
  x: 17.32,
  y: 4.31,
  width: 1,
  height: 1,
  transform: "translate(8.62 -11.19) rotate(45)"
})));

function SvgSettings(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 19.58 19.9"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "static/media/settings.4229168f.svg";
export { SvgSettings as ReactComponent };